<div class="table-container">
    <ul>
        <table class="table2">
            <thead>
                <th class="centro-align">
                    <div class="div-flex">
                        <div class="sub-header left">
                            <!-- Input fields to select the date range -->
                            <input #dateInput type="date" [(ngModel)]="startDate" class="select-input">
                            <input #dateInput2 type="date" [(ngModel)]="endDate" class="select-input">
                            <!-- Button to trigger the filter -->
                            <button (click)="applyDateFilter()" class="select-input">Aplicar Filtro</button>
                            <button class="select-input" (click)="clearFilter()">Limpar filtro</button>
                            <input type="text" name="searchText" [(ngModel)]="searchText" (input)="filterItems()"
                                placeholder="Find" class="ultimo-input">
                            <div *ngIf="filteredItems" class="sub-header">
                                <span style=" display: flex; align-items: center; margin: 0;">Total Rotas: {{
                                    filteredItems.length }} </span>
                            </div>
                            <div class="sub-header right">
                                <div class="icone-setting">
                                    <!-- <i-feather name="printer"></i-feather> -->
                                    <button class="btn-frete icone-setting" mat-button
                                        (click)="exportExcel()"><i-feather name="printer"></i-feather>Print</button>
                                </div>
                                <!-- <button class="btn-frete" mat-button (click)="exportExcel()">
                                        <span class="material-icons">print</span> Print
                                    </button> -->
                            </div>
                        </div>
                        <!-- <div>
                            <label class="totais">Data: <abbr style="color: #89bb01; font-weight: bold;">{{
                                referenceDate }}</abbr></label>
                        </div> -->
                        <div class="sub-header div-margin-left">
                            <button [disabled]="isCarrierJSLEnabled" (click)="milkRunSPFilter()" class="select-input"
                                [ngClass]="{'botaoMRSP': milkRunSP}">Milk
                                Run JSL</button>
                            <button [disabled]="isCarrierTCMEnabled" (click)="milkRunSulFilter()" class="select-input"
                                [ngClass]="{'botaoMRSP': milkRunSul}">Milk
                                Run TCM</button>
                            <button [disabled]="isCarrierJSLARGEnabled" (click)="milkRunArgFilter()"
                                class="select-input" [ngClass]="{'botaoMRSP': milkRunArg}">Milk
                                Run Arg</button>
                            <button [disabled]="isCarrierJSLARGEnabled" (click)="embalagemFilter()" class="select-input"
                                [ngClass]="{'botaoMRSP': embalagens }">Embalagens ARG</button>
                            <button [disabled]="isCarrierJSLARGEnabled" (click)="containerFilter()" class="select-input"
                                [ngClass]="{'botaoMRSP': container}">Container IMP</button>
                            <button [disabled]="isCarrierJSLARGEnabled" (click)="containerFilterEXP()"
                                class="select-input" [ngClass]="{'botaoMRSP': containerEXP}">Container EXP</button>
                            <button [disabled]="isCarrierJSLARGEnabled" (click)="aereoFilter()"
                                class="select-input" [ngClass]="{'botaoMRSP': aereo}">Aéreo</button>
                            <button [disabled]="isCarrierEnabled" (click)="interplantasFilter()" class="select-input"
                                [ngClass]="{'botaoMRSP': interplantas}">Interplantas</button>
                            <button (click)="updateFilter()" class="select-input btnRefresh">Atualizar</button>
                        </div>
                    </div>
                </th>

                <!-- <th class="centro-align">Total de viagens: {{ filteredItems.length }}</th> -->

            </thead>
        </table>

        <div *ngIf="filteredItems">
            <table style="width: 100%;" class="table2">
                <tr class="table2">
                    <td style="width: 20%;" class="table2"><strong>Filling Rate: </strong>{{ fillingRate |
                        number:
                        '1.2-2'
                        }}%
                    </td>
                    <td style="width: 20%;" class="table2">
                        <strong>Porcentagem de Veículos Pequenos:</strong> {{ veiculosPequenos |
                        number:
                        '1.2-2' }}%
                    </td>
                    <td style="width: 20%;" class="table2">
                        <strong>Porcentagem de Veículos Médios:</strong> {{ veiculosMedios |
                        number: '1.2-2'
                        }}%
                    </td>
                    <td style="width: 20%;" class="table2">
                        <strong>Porcentagem de Veículos Grandes:</strong> {{ veiculosGrandes |
                        number: '1.2-2'
                        }}%
                    </td>
                    <td style="width: 20%;" class="table2">
                        <strong>Custo Total:</strong> {{ calcularSomaCustoViagem() | currency:'BRL' }}
                    </td>


                </tr>
            </table>

        </div>

        <div *ngIf="filteredItems">
            <table style="width: 100%;" class="table2">
                <tr class="table2">
                    <td style="width: 20%;" class="table2"><strong>Cumprimento de Janelas: </strong>{{
                        (valorUmTotal / totalItensValidos) * 100
                        | number: '1.2-2' }}%
                    </td>
                    <td style="width: 20%;" class="table2">
                        <strong>Distância Total:</strong> {{ somaTotalDistance | number: '1.2-2' }}Km
                    </td>
                    <td style="width: 20%;" class="table2">
                        <strong>Peso Total:</strong> {{ somaWeightLoaded | number: '1.2-2' }}Ton
                    </td>
                    <td style="width: 20%;" class="table2">
                        <strong>Emissão CO2:</strong> {{ emissao |
                        number: '1.2-2' }}KgCO2/Ton
                    </td>
                    <td style="width: 20%;" class="table2">
                        <strong>Eficiência de Transporte:</strong> {{ getPercentComentNotEmpty() | number: '1.2-2' }}%
                    </td>
                </tr>
            </table>

        </div>

        <div class="table2">
            <table id="relatorio-table">
                <thead>
                    <tr>
                        <th>Data</th>
                        <th>Tipo de Veículo</th>
                        <!-- <th>Transportadora</th> -->
                        <th>
                            <select [(ngModel)]="filtroAtual" (change)="filtrarTransportadora($event)">
                                <option value="Transportadoras">Transportadoras</option>
                                <option *ngFor="let transportadora of transportadoras">{{ transportadora }}</option>
                            </select>
                        </th>
                        <th>Placa do Veículo</th>
                        <th>Fornecedores</th>
                        <th>Desvios</th>
                        <th>Qtde Itens</th>
                        <th>Cubagem (m³)</th>
                        <th>Peso Total (Kg)</th>
                        <th>Filling Rate (%)</th>
                        <th>Distância Total (Km)</th>
                        <th>Custo da Viagem (R$)</th>
                        <th>Reportar</th>
                        <th>Deletar</th>
                    </tr>
                </thead>
                <!-- <tbody *ngFor="let item of filteredItems"> -->
                <tbody *ngFor="let item of filteredItems  | paginate: { itemsPerPage: count, currentPage: p }">
                    <tr [ngClass]="{ 'black-row': $even, 'grafiti-row': $odd }">
                        <td>
                            {{ isValidDate(item.dataReferencia) ? (item.dataReferencia | date : 'dd MM yyyy': 'UTC') :
                            '' }}
                            <!-- {{ item.date ? (item.date | date : 'dd MM yyyy': 'UTC') : '' }} -->
                            <!-- {{ item.date && !isNaN(item.date.getTime()) ? (item.date | date : 'dd MM yyyy': 'UTC') : '' }} -->
                            <!-- {{ item.date && !isNaN(new Date(item.date).getTime()) ? (item.date | date : 'dd MM yyyy': 'UTC') : '' }} -->
                        </td>
                        <td [class.background-red]="!item.modeloValido" (click)="veiculoDialog(item)">
                            {{ item['Transport Type'] ? (item['Transport Type']) : '' }}
                        </td>
                        <td [class.background-red]="!item.Transportadora && !item.transportadora">
                            {{ item['Transportadora'] ? (item['Transportadora']) : (item['transportadora']) }}
                        </td>
                        <td [ngClass]="{ 'background-red': !isValorValido(item.Plate) }"
                            (click)="editPlaca(item, 'Plate')">
                            {{ isValorValido(item.Plate) ? (item.Plate ) : '' }}
                        </td>
                        <td (click)="imprimeItem(item)" style="text-align: left;">
                            <!--(click)="editField(item, 'Fornecedor 1')"> -->
                            {{ item['Fornecedor 1'] }}
                            <span *ngIf="isValorValido(item['Fornecedor 2'])"> + {{ item['Fornecedor 2'] }}</span>
                            <span *ngIf="isValorValido(item['Fornecedor 3'])"> + {{ item['Fornecedor 3'] }}</span>
                            <span *ngIf="isValorValido(item['Fornecedor 4'])"> + {{ item['Fornecedor 4'] }}</span>
                        </td>
                        <td>
                            <i-feather name="alert-triangle" *ngIf="hasComent(item)" title="{{ item.Coment }}"
                                class="red-icon"></i-feather>
                        </td>

                        <td [ngClass]="{ 'background-red': !isValorValido(item.Volumes) }"
                            (click)="editField(item, 'Volumes')">
                            {{ isValorValido(item.Volumes) ? (item.Volumes ) : '' }}
                        </td>
                        <td [ngClass]="{ 'background-red': !isValorValido(item.Cubage) }"
                            (click)="editField(item, 'Cubage')">
                            {{ isValorValido(item.Cubage) ? (item.Cubage | number: '1.2-2': 'pt'): '' }}
                        </td>

                        <td [ngClass]="{ 'background-red': !isValorValido(item['Weight Loaded']) }"
                            (click)="editField(item, 'Weight Loaded')">
                            {{ item['Weight Loaded'] ? (item['Weight Loaded'] | number: '1.2-2': 'pt') : ''}}
                        </td>

                        <!-- <ng-container *ngIf="findVeiculoByModelo(item['Transport Type']) as veiculo"> -->
                        <td [ngClass]="{ 'background-red': !isValorValidoFinite(item.fillingRateMax) }">
                            {{ item.fillingRateMax ? (item.fillingRateMax | number:
                            '1.2-2': 'pt') : '' }}
                        </td>
                        <!-- </ng-container> -->
                        <td [ngClass]="{ 'background-red': !isValorValido(item['Total Distance']) }"
                            (click)="editField(item, 'Total Distance')">
                            {{ isValorValido(item['Total Distance']) ? (item['Total Distance'] | number: '1.2-2': 'pt'):
                            '' }}
                        </td>
                        <td [ngClass]="{ 'background-red': !isValorValido(item['Total Cost']) }"
                            (click)="editField(item, 'Total Cost')">
                            {{ isValorValido(item['Total Cost']) ? (item['Total Cost'] | number: '1.2-2': 'pt') : ''
                            }}
                        </td>
                        <td>
                            <i-feather name="message-circle" (click)="InsereComent(item, 'Coment')"></i-feather>
                        </td>
                        <td>
                            <i-feather name="delete" (click)="deleteItem(item, urlConsulta, query)"
                                class="button-spacing"></i-feather>
                        </td>
                    </tr>
                    <!-- ... Your other table rows ... -->
                </tbody>
            </table>
            <div class="paginator">
                <pagination-controls (pageChange)="p = $event"></pagination-controls>
            </div>
        </div>
    </ul>
</div>

<clr-modal [(clrModalOpen)]="dialogOpen" [clrModalSize]="'md'" class="dialog-container">
    <h2 class="modal-title">Adicionar Fornecedor</h2>
    <div class="modal-body">
        <form class="inputs">
            <div>
                <label class="modal-label">Fornecedor</label>
                <input type="string" name="fornecedor" [(ngModel)]="item.local" class="modal-input1">
            </div>
            <div>
                <label class="modal-label">e-mail</label>
                <input type="string" name="email" [(ngModel)]="item.contato" class="modal-input2">
            </div>
            <div>
                <label class="modal-label">Endereço</label>
                <input type="string" name="endereco" [(ngModel)]="item.endereco" class="modal-input3">
            </div>
            <div>
                <label class="modal-label">Latitude</label>
                <input type="string" name="latitude" [(ngModel)]="item.latitude" class="modal-input4">
                <label class="modal-label">Longitude</label>
                <input type="string" name="logitude" [(ngModel)]="item.longitude" class="modal-input4">
            </div>

            <div>
                <label class="modal-label">Local de Descarga?</label>
                <input type="checkbox" id="descarga" name="descarga" [(ngModel)]="item.descarga">
            </div>

            <div class="modal-div">
                <button class="modal-button" type="button" (click)="salvar()">Save</button>
                <button class="modal-button" type="button" (click)="cancel()">Cancel</button>
            </div>
        </form>
    </div>
</clr-modal>

<clr-modal [(clrModalOpen)]="dialogTiposOpen" [clrModalSize]="'md'" class="dialog-container">
    <h2 class="modal-title">Cadastrar Tipo de Veículo</h2>
    <div class="modal-body">
        <form class="inputs">
            <table class="table2000" style="width: 100%;">
                <tr>
                    <td>
                        <label class="modal-label">Placa</label>
                    </td>
                    <td>
                        <input type="string" name="Plate" [(ngModel)]="item.Plate" class="modal-input1">
                    </td>
                    <td>
                        <label class="modal-label">Modelo</label>
                    </td>
                    <td>
                        <!-- <input type="string" name="modelo" [(ngModel)]="item['Transport Type']" class="modal-input1"> -->
                        <select id="Transport Type" name="Transport Type" [(ngModel)]="item['Transport Type']"
                            class="modal-select" (change)="onModelChange()">
                            <option *ngFor="let veiculo of veiculos" [value]="veiculo.modelo">{{
                                veiculo.modelo }}
                            </option>
                        </select>
                    </td>
                </tr>
            </table>
            <table class="table2000">
                <tr>
                    <td>
                        <label class="modal-label">Transportadora</label>
                    </td>
                    <td>
                        <select id="Transportadora" name="Transportadora" [(ngModel)]="item.Transportadora"
                            class="modal-select">
                            <option *ngFor="let transportadora of carrier" [value]="transportadora.name">{{
                                transportadora.name }}
                            </option>
                        </select>
                    </td>
                </tr>
            </table>

            <table class="table2000">
                <tr>
                    <td>
                        <label class="modal-label">Perfil</label>
                    </td>
                    <td>
                        <input type="string" name="veiculoPerfil" [(ngModel)]="item.veiculoPerfil" class="modal-input1">
                        <!-- <select id="veiculoPerfil" name="veiculoPerfil" [(ngModel)]="item.veiculoPerfil"
                            class="modal-select">
                            <option *ngFor="let perfil of perfilVehicles" [value]="perfil">{{ perfil }}
                            </option>
                        </select> -->
                    </td>
                </tr>
            </table>
            <table class="table2000">
                <tr>
                    <td>
                        <label class="modal-label">Combustivel</label>
                    </td>
                    <td>
                        <select id="combustivel" name="perfil" [(ngModel)]="item.combustivel" class="modal-select1">
                            <option *ngFor="let combustivel of combustiveis" [value]="combustivel">{{ combustivel }}
                            </option>
                        </select>
                    </td>
                    <td>
                        <label class="modal-label">Emissões</label>
                    </td>
                    <td>
                        <input type="string" name="emissao" [(ngModel)]="item.emissao" class="modal-input4">
                    </td>
                    <td>
                        <label class="modal-label">Consumo</label>
                    </td>
                    <td>
                        <input type="string" name="consumo" [(ngModel)]="item.consumo" class="modal-input4">
                    </td>
                </tr>
            </table>
            <table class="table2000">
                <tr>
                    <button class="modal-button" type="button" (click)="salvarVeiculo()">Save</button>
                    <button class="modal-button" type="button" (click)="cancel()">Cancel</button>
                </tr>

            </table>
        </form>
    </div>
</clr-modal>

<div *ngIf="!filteredItems || isLoading" class="spinner-overlay">
    <div class="spinner">
        <mat-spinner></mat-spinner>
    </div>
</div>